import { Injectable, inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AlertsFunctions } from '@shared/helpers/functions/alerts-functions.helper';
import { resolveErrorMessage } from '@shared/helpers/functions/error-message.helper';
import { WsSyncConfigRepository } from '../repositories/ws-sync-config.repository';
import { WsSyncState } from '../state/ws-sync.state';
import { WsSyncToggleCommand } from '../interfaces/ws-sync-state.types';

@Injectable({ providedIn: 'root' })
export class SaveWsSyncStateUseCase {
  private readonly repository = inject(WsSyncConfigRepository);
  private readonly state = inject(WsSyncState);
  private readonly alertsFunctions = inject(AlertsFunctions);

  execute(command: WsSyncToggleCommand): void {
    const { idMarca, idSubmarca, active } = command;
    if (!idMarca || !idSubmarca) return;
    if (this.state.isPending(idMarca, idSubmarca)()) return;

    // Set optimista: el switch refleja el cambio de inmediato y el error lo revierte.
    const previous = this.state.getSync(idMarca, idSubmarca);
    this.state.markPending(idMarca, idSubmarca);
    this.state.setSync(idMarca, idSubmarca, active);
    if (active) {
      this.state.notifySyncStarted();
    }
    this.repository
      .toggleSync(command)
      .pipe(finalize(() => this.state.clearPending(idMarca, idSubmarca)))
      .subscribe({
        next: () => this.state.setSync(idMarca, idSubmarca, active),
        error: (err) => {
          this.state.setSync(idMarca, idSubmarca, previous);
          if (active) {
            this.state.dismissSyncAlert();
          }
          this.alertsFunctions.showErrorAlert(resolveErrorMessage(err));
        },
      });
  }
}
